import React from "react";
import { StyleSheet, Text, View, Image } from "react-native";
import MenuIcon from "../Components/MenuIcon";
import screenStyles from "./ScreenStyles";
import settings from "../Config/EnvironmentSettings";

const styles = StyleSheet.create({
  companyText: {
    color: "white",
    backgroundColor: "black",
    borderRadius: 8,
    borderColor: "#fff",
    textAlign: "center",
  },
  debugbox: {
    borderWidth: 5,
    borderStyle: "solid",
  },
});

const Home = ({ toggleSideMenu, menuOpen }) => {
  return (
    <View style={screenStyles.container}>
      <View style={menuOpen ? screenStyles.hidden : screenStyles.visible}>
        <MenuIcon handler={toggleSideMenu}></MenuIcon>
      </View>
      <View
        style={[screenStyles.mainContent, { margin: 100 }]}
        nativeID="mainContent"
      >
        <Image
          style={{ width: 20, height: 20, padding: 50 }}
          source={{
            uri: `${settings.blogLogosCDN}/logo-square.png`,
          }}
        />
        <Text style={styles.companyText}>
          {" Created by BICM Consulting Ltd. "}
        </Text>
      </View>
    </View>
  );
};

export default Home;
